import { render, staticRenderFns } from "./bankIndustry.vue?vue&type=template&id=e13228f2"
import script from "./bankIndustry.vue?vue&type=script&lang=js"
export * from "./bankIndustry.vue?vue&type=script&lang=js"
import style0 from "./bankIndustry.vue?vue&type=style&index=0&id=e13228f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports